import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, throwError } from 'rxjs';
import { IRequestLogin, IRequestUser, IRequestUserUpdatePassword, IResponseLogin, IResponseUser, IResponseUserInfo } from './user-api.model.interface';
import { IResponse } from '../api-models-base.interface';

export const URL_LOGIN = environment.host + '/Usuario/Login'
const URL_ADD = environment.host + '/Usuario'
const URL_LIST = environment.host + '/Usuario'
const URL_UPDATE = environment.host + '/Usuario'
const URL_UPDATE_PASSWORD = 'UpdatePassword'
const URL_GET_PASSWORD = environment.host + '/Usuario/GetPassword'

@Injectable({
	providedIn: 'root'
})

export class UserApiService {
    constructor(private _httpClient: HttpClient) { }

	login(request: IRequestLogin): Observable<IResponse<IResponseLogin>> {
		return this._httpClient.post<IResponse<IResponseLogin>>(URL_LOGIN, request);
	}

	add(request: IRequestUser): Observable<IResponse<string>> {
		return this._httpClient.post<IResponse<string>>(URL_ADD, request).pipe(
			catchError((error) => {
				console.log('error service http-->', error);
				return throwError(() => error);
			})
		);
	}

	getUserById(id: number): Observable<IResponse<IResponseUser>> {
		const url = `${URL_UPDATE}/${id}`;
		return this._httpClient.get<IResponse<IResponseUser>>(url);
	}

	update(userId: number, request: IRequestUser): Observable<IResponse<string>> {
		const url = `${URL_UPDATE}/${userId}`;
		return this._httpClient.put<IResponse<string>>(url, request).pipe(
			catchError((error) => {
				console.log('error service http-->', error);
				return throwError(() => error);
			})
		);
	}

	list(filter?: string, page?: number, rows?: number): Observable<IResponse<IResponseUserInfo[]>> {
		let params = new HttpParams();
		if (filter) {
			params = params.set('filter', filter);
		}

		if (page) {
			params = params.set('page', page);
		}

		if (rows) {
			params = params.set('rows', rows);
		}

		return this._httpClient.get<IResponse<IResponseUserInfo[]>>(URL_LIST, { params });
	}

	getPassword(userId: number): Observable<IResponse<string>> {
		const url = `${URL_GET_PASSWORD}/${userId}`;	
		return this._httpClient.get<IResponse<string>>(url);
	  
	}

	updatePassword(userId: number, newPassword: string): Observable<IResponse<string>> {
		const url = `${URL_UPDATE}/${userId}/${URL_UPDATE_PASSWORD}`;

		const request: IRequestUserUpdatePassword = {
			clave: newPassword
		};

		return this._httpClient.patch<IResponse<string>>(url, request);
	}
}